const alignmentTypes = {
  start: 'start',
  end: 'end',
  center: 'center',
};

export const getAlignmentBasedFlexDirection = (
  buttonsAlignment: string,
  alignmentDirection: string,
) => {
  if (alignmentDirection === 'center') {
    return {
      'justify-content': 'center',
      'align-items': 'center',
    };
  }

  if (buttonsAlignment === 'vertical') {
    return {
      'justify-content': 'center',
      'align-items':
        alignmentDirection === alignmentTypes.start ? 'start' : 'end',
    };
  }

  return {
    'justify-content':
      alignmentDirection === alignmentTypes.start ? 'start' : 'end',
    'align-items': 'center',
  };
};
